import React from 'react';
import './About.css';

const About = ({ navigateTo }) => {
    return (
        <div className="about-container">
            <div className="about-content">
                <h1>About Flappy Bird</h1>
                
                <div className="about-section">
                    <div className="about-image">
                        <img src="https://raw.githubusercontent.com/sourabhv/FlapPyBird/master/assets/sprites/yellowbird-midflap.png" 
                            alt="Flappy Bird" className="bird-icon" />
                    </div>
                    <div className="about-text">
                        <h2>Our Story</h2>
                        <p>
                            Flappy Bird is a reimagined version of the classic mobile game that took the world by storm. Our version adds new features and improvements while maintaining the simple but addictive gameplay of the original.
                        </p>
                        <p>
                            The game was developed as a passion project by a team of game enthusiasts who wanted to create a modern web-based version with progressive difficulty levels, colorful visuals, and social sharing capabilities.
                        </p>
                    </div>
                </div>
                
                <div className="about-section">
                    <h2>Game Features</h2>
                    <div className="features-grid">
                        <div className="feature">
                            <h3>100 Challenging Levels</h3>
                            <p>Progress through 100 levels with increasing difficulty as the gaps between pipes get narrower.</p>
                        </div>
                        <div className="feature">
                            <h3>Colorful Visuals</h3>
                            <p>Enjoy vibrant, colorful graphics with unique color schemes for each level.</p>
                        </div>
                        <div className="feature">
                            <h3>Progressive Speed</h3>
                            <p>Experience increasing game speed as you play longer, adding an extra layer of challenge.</p>
                        </div>
                        <div className="feature">
                            <h3>Social Sharing</h3>
                            <p>Share your high scores with friends across multiple social media platforms.</p>
                        </div>
                    </div>
                </div>
                
                <div className="about-section">
                    <h2>How to Play</h2>
                    <p>
                        The goal is simple: navigate the bird through the gaps between pipes without touching them. The longer you survive, the higher your score.
                    </p>
                    <ul>
                        <li><strong>Click</strong> or press <strong>Spacebar</strong> to make the bird flap and fly upward</li>
                        <li>Navigate through the <strong>gaps</strong> between the green pipes</li>
                        <li>Each pipe you pass increases your <strong>score</strong> by 1</li>
                        <li>Every 20 pipes, you'll advance to the next <strong>level</strong> with narrower gaps</li>
                        <li>The game ends when the bird touches a pipe or the ground</li>
                    </ul>
                </div>
                
                <div className="about-section">
                    <h2>Contact Us</h2>
                    <p>
                        Have questions, feedback, or suggestions? We'd love to hear from you!
                    </p>
                    <p>
                        <strong>Email:</strong> contact@flappybird.tv
                    </p>
                </div>
                
                <button className="back-button" onClick={() => navigateTo('game')}>
                    Back to Game
                </button>
            </div>
        </div>
    );
};

export default About; 